import { render, staticRenderFns } from "./FlexLayout.vue?vue&type=template&id=738ca768&scoped=true&"
import script from "./FlexLayout.vue?vue&type=script&lang=js&"
export * from "./FlexLayout.vue?vue&type=script&lang=js&"
import style0 from "./FlexLayout.vue?vue&type=style&index=0&id=738ca768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738ca768",
  null
  
)

export default component.exports